const AUTH0_CONFIG = {
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  cacheLocation: 'localstorage' // 'memory
}

const API_CONFIG = {
  baseUrl: process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://reports-api.tema-q.de',
  resultsCount: 10
}

export {
  AUTH0_CONFIG,
  API_CONFIG
}
